import { Typography, Box, useTheme, TextField, Divider, Button, Grid, Dialog, Tooltip, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { Edit } from "@mui/icons-material";

import IconButton from '@mui/material/IconButton';
import { Production_API_ENDPOINTS } from "../../config/api/apiCallProduction";



const AddQCPropertyMaster = ({ handleBackWinderMachineEntry, }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
  
    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [status, setStatus] = useState('Active');
    const [openDialog, setOpenDialog] = useState(false);
    const [btntext, setBtntext] = useState('Add');

    const handleOpen = (row = null) => {
        if (row) {

            setPropertyID(row.id);
            setSelectedPropertyName(row.property_name);
            setSelectedunit(row.unit);
            setSelectedSpecification(row.specification);
            setStatus(row.status);

            setBtntext('Update')

        } else {
            setPropertyID(0);
            setSelectedPropertyName('');
            setSelectedunit('');
            setSelectedSpecification('');

            setStatus('Active')

            setBtntext('Add')
        }
        setOpenDialog(true);
    };

    const clear =() =>{

           setPropertyID(0);
            setSelectedPropertyName('');
            setSelectedunit('');
            setSelectedSpecification('');

            setStatus('Active')

            setBtntext('Add')
    }


    const CategoryColumns = [
        {
            field: "actions",
            headerName: "",
            width: 60,
            sortable: false,
            filterable: false,
            renderCell: (params) => (


                <>
                    <Tooltip title="Edit" arrow>
                        <IconButton color="info" onClick={() => handleOpen(params.row)}>
                            <Edit fontSize="small" />
                        </IconButton>
                    </Tooltip>


                    {/* <Tooltip title="Delete">
                        <IconButton
                            color="error"

                            onClick={() => handleAddDeleteSubCategory('DELETE', params.row.id)}
                        >
                            <DeleteForeverIcon />
                        </IconButton>
                    </Tooltip> */}


                </>
            )
        },
        {
            field: 'sno',
            headerName: 'S.No',
            width: 80,
            sortable: false,
            filterable: false,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
        },

        {
            field: "property_name",
            headerName: "Property Name",
             width: 170,
            cellClassName: "name-column--cell"

        },
        {
            field: "unit",
            headerName: "Unit",
            // width: 170,
            cellClassName: "name-column--cell"

        },
        {
            field: "specification",
            headerName: "Specification",
            // width: 170,
            cellClassName: "name-column--cell"

        },

       


    ];

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [partyType, setPartyType] = useState([]);
    const [selectedPartyType, setSelectedPartyType] = useState(null);

    const [selectedPropertyName, setSelectedPropertyName] = useState(null);
    const [selectedunit, setSelectedunit] = useState(null);
    const [selectedSpecification, setSelectedSpecification] = useState(null);

    const [propertyid, setPropertyID] = useState(0);

    useEffect(() => {
        if (!isDataLoaded) {
            LoadQCPropertyList();
        }
    }, [isDataLoaded]);

    const LoadQCPropertyList = () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
        }
        callApi(Production_API_ENDPOINTS.getMasterQCPropertyList, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyType(data);
                }
            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
                // 

            });
    }



    const handleAddDeleteQCProperty = (mode, id) => {
        setParentRollMsgOpen(false);

        if (mode === 'DELETE') {
            if (window.confirm("Are you sure you want to delete this party type?")) {
                // If user confirms, proceed with deletion
                setSelectedPartyType(null);
            }
            else {
                // If user cancels, exit the function
                return;
            }
        }

        // validation
        let isValid = true;
        let validation_msg = '';

        if (selectedPropertyName === '') {
            validation_msg += 'Please enter the Property Name.\n';
            isValid = false;
        }

        if (selectedunit === '') {
            validation_msg += 'Please enter the Unit.\n';
            isValid = false;
        }

        // if (selectedSpecification === '') {
        //     validation_msg += 'Please enter the Specification.\n';
        //     isValid = false;
        // }

        if (isValid) {
            const SaveData = {
                p_property_id: id,  // required for backend to know operation
                p_property_name: selectedPropertyName,
                p_unit: selectedunit,
                p_specification: selectedSpecification,
                p_remarks: '',
            };

            callApi(Production_API_ENDPOINTS.CrudQualityCertificatePropertyMaster, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value === 0) {
                            const action = mode === 'ADD' ? 'added' : 'deleted';
                            toast.success(`Property attributes ${action} successfully.`, { position: toast.POSITION.BOTTOM_CENTER });
                            LoadQCPropertyList();
                            clear();
                        }

                        else if (data[0].result_value === 2) {
                            const action = 'updated';
                            toast.success(`Property attributes ${action} successfully.`, { position: toast.POSITION.BOTTOM_CENTER });
                            LoadQCPropertyList();
                             clear();
                        }
                        else if (data[0].result_value === 1) {
                            const message = mode === 'ADD'
                                ? 'Property already exists.'
                                : 'Property not found.';
                            toast.error(message, { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].result_value === -1) {
                            toast.error('Invalid Mode Specified.', { position: toast.POSITION.BOTTOM_CENTER });
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };


    return (

        <Dialog
            open={true}
            onClose={handleBackWinderMachineEntry}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography variant="h5" fontWeight={'bold'}>QC Property Master</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Property Name</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField placeholder='Enter the Property Name' value={selectedPropertyName} color="secondary" onChange={(e) => setSelectedPropertyName(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>                               </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={4}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Unit</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField placeholder='Enter the Unit' value={selectedunit} color="secondary" onChange={(e) => setSelectedunit(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>                               </Box>
                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}

                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={4}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Specification</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField placeholder='Enter the Specification' value={selectedSpecification} color="secondary" onChange={(e) => setSelectedSpecification(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>                               </Box>
                            </Box>                  


                            <Box marginTop={6}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button
                                        onClick={() =>
                                            btntext === 'Add'
                                                ? handleAddDeleteQCProperty('ADD', null)
                                                : handleAddDeleteQCProperty('UPDATE', propertyid)
                                        }
                                        size="small"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        {btntext}
                                    </Button>

                                    <Button size="small"

                                        variant="contained"
                                        sx={{
                                            marginLeft: "10px",
                                            backgroundColor: '#6C757D',
                                            color: '#fff',
                                            '&:hover': {
                                                backgroundColor: '#6C757D'
                                            }
                                        }}

                                        onClick={() => handleOpen(null)} >
                                        Clear
                                    </Button>
                                </Box>
                            </Box>

                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6" sx={{ marginTop: '10px', marginBottom: '10px' }}> QC Property list</Typography>

                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"

                                    height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    <DataGrid name="dgv-orderselection" getRowId={(row) => row.id} pageSize={5} columnHeaderHeight={35} rowHeight={35} rows={partyType} columns={CategoryColumns}


                                    />

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>

            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button onClick={handleBackWinderMachineEntry} size='small' variant="outlined" color="error" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddQCPropertyMaster;